// Chakra imports
import {
  Portal,
  useDisclosure,
  Box,
  useColorMode,
} from "@chakra-ui/react";
import Configurator from "components/Configurator/Configurator";
import Footer from "components/Footer/Footer.js";
import {
  LogoImage,
} from "components/Icons/Icons";
// Layout components
import AdminNavbar from "components/Navbars/AdminNavbar.js";
import Sidebar from "components/Sidebar/Sidebar.js";
import React, { useState } from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import routes from "routes.js";
import { getUserData } from "../utils/auth";
// Custom Chakra theme
// Custom components
import MainPanel from "../components/Layout/MainPanel";
import PanelContainer from "../components/Layout/PanelContainer";
import PanelContent from "../components/Layout/PanelContent";
import bgAdmin from "assets/img/admin-background.png";
import AuthWrapper from "../components/AuthWrapper";

export default function Dashboard(props) {
  const { ...rest } = props;
  // states and functions
  const [fixed, setFixed] = useState(false);
  const { colorMode } = useColorMode();
  
  // Safety check for routes
  if (!routes || !Array.isArray(routes)) {
    console.error('Routes is not properly defined:', routes);
    return <div>Error: Routes configuration is invalid</div>;
  }
  // functions for changing the states from components
  const getRoute = () => {
    return window.location.pathname !== "/admin/full-screen-maps";
  };
  const getActiveRoute = (routes) => {
    let activeRoute = "Default Brand Text";
    
    // Safety check for routes
    if (!routes || !Array.isArray(routes)) {
      return activeRoute;
    }
    
    for (let i = 0; i < routes.length; i++) {
      if (routes[i].collapse) {
        let collapseActiveRoute = routes[i].views && Array.isArray(routes[i].views) ? getActiveRoute(routes[i].views) : activeRoute;
        if (collapseActiveRoute !== activeRoute) {
          return collapseActiveRoute;
        }
      } else if (routes[i].category) {
        let categoryActiveRoute = routes[i].views && Array.isArray(routes[i].views) ? getActiveRoute(routes[i].views) : activeRoute;
        if (categoryActiveRoute !== activeRoute) {
          return categoryActiveRoute;
        }
      } else {
        if (
          window.location.href.indexOf(routes[i].layout + routes[i].path) !== -1
        ) {
          return routes[i].name;
        }
      }
    }
    return activeRoute;
  };
  // This changes navbar state(fixed or not)
  const getActiveNavbar = (routes) => {
    let activeNavbar = false;
    
    // Safety check for routes
    if (!routes || !Array.isArray(routes)) {
      return activeNavbar;
    }
    
    for (let i = 0; i < routes.length; i++) {
      if (routes[i].category) {
        let categoryActiveNavbar = routes[i].views && Array.isArray(routes[i].views) ? getActiveNavbar(routes[i].views) : activeNavbar;
        if (categoryActiveNavbar !== activeNavbar) {
          return categoryActiveNavbar;
        }
      } else {
        if (
          window.location.href.indexOf(routes[i].layout + routes[i].path) !== -1
        ) {
          if (routes[i].secondaryNavbar) {
            return routes[i].secondaryNavbar;
          }
        }
      }
    }
    return activeNavbar;
  };
  const getRoutes = (routes) => {
    // Safety check for routes
    if (!routes || !Array.isArray(routes)) {
      return null;
    }
    
    return routes.map((prop, key) => {
      if (prop.collapse) {
        return prop.views && Array.isArray(prop.views) ? getRoutes(prop.views) : null;
      }
      if (prop.category === "account") {
        return prop.views && Array.isArray(prop.views) ? getRoutes(prop.views) : null;
      }
      if (prop.layout === "/admin") {
        return (
          <Route
            path={prop.layout + prop.path}
            component={prop.component}
            key={key}
          />
        );
      } else {
        return null;
      }
    });
  };
  const { isOpen, onOpen, onClose } = useDisclosure();
  // Ensure RTL direction is maintained
  document.documentElement.dir = "rtl";
  // Chakra Color Mode
  return (
    <AuthWrapper>
      <Box>
        <Box
          minH='40vh'
          w='100%'
          position='absolute'
          bgImage={colorMode === "light" ? bgAdmin : "none"}
          bg={colorMode === "light" ? bgAdmin : "navy.900"}
          bgSize='cover'
          top='0'
        />
        <Sidebar
          routes={routes}
          logo={
            <LogoImage w='120px' h='40px' />
          }
          display='none'
          {...rest}
        />
        <MainPanel
          w={{
            base: "100%",
            xl: "calc(100% - 275px)",
          }}>
          <Portal>
            <AdminNavbar
              onOpen={onOpen}
              brandText={getActiveRoute(routes)}
              secondary={getActiveNavbar(routes)}
              fixed={fixed}
              {...rest}
            />
          </Portal>
          {getRoute() ? (
            <PanelContent>
              <PanelContainer>
                <Switch>
                  {getRoutes(routes)}
                  {/* Companies as default for company session */}
                  {(() => {
                    let isCompany = false;
                    try { const u = getUserData(); isCompany = !!(u && (u.logo || typeof u.user_id !== 'undefined')); } catch {}
                    return isCompany ? (
                      <Redirect from='/admin' to='/admin/companies' />
                    ) : (
                      <Redirect from='/admin' to='/admin/dashboard' />
                    );
                  })()}
                </Switch>
              </PanelContainer>
            </PanelContent>
          ) : null}
          <Footer />
          <Configurator
            secondary={getActiveNavbar(routes)}
            isOpen={isOpen}
            onClose={onClose}
            isChecked={fixed}
            onSwitch={(value) => {
              setFixed(value);
            }}
          />
        </MainPanel>
      </Box>
    </AuthWrapper>
  );
}
